<template>
  <b-modal
    v-if="!isLoading && onChangeSafetyPopupModal && terms_conditions_html"
    v-model="onChangeSafetyPopupModal"
    :id="getModals.safetyPopupModalId"
    :ref="getModals.safetyPopupModalId"
    title="Terms Conditions"
    class="imp-popup"
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
  >
    <div>
      <div class="px-3 py-3">
        <div style="overflow-x: scroll; height: 60vh">
          <span v-html="terms_conditions_html"></span>
        </div>
        <div class="col-12 col-sm-10 col-md-6 col-lg-4 mx-auto">
          <button
            class="btn btn-primary w-100"
            @click="onHandleCloseModal('safetyPopupModal')"
          >
            I agree
          </button>
        </div>
      </div>
      <div class="rainbow-line">
        <span v-for="(rainbowLine, rlIndex) in 7" :key="rlIndex"></span>
      </div>
    </div>
  </b-modal>
</template>
<script>
import MasterService from "@/apiServices/MasterService";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      terms_conditions_html: "",
      contentLoaded: false,
    };
  },
  computed: {
    onChangeSafetyPopupModal: {
      get() {
        return this.getModals.safetyPopupModal;
      },
      set(value) {
        !value ? this.onHandleCloseModal("safetyPopupModal") : undefined;
      },
    },
    ...mapGetters([
      // Modal
      "getModals",
    ]),
  },
  methods: {
    ...mapActions(["onHandleCloseModal"]),
    async getTermsConditions() {
      try {
        let response = await MasterService.GetTermsConditions();
        if (response.data.data[0] && response.data.data[0].tc_text) {
          this.terms_conditions_html = response.data.data[0].tc_text;
          this.contentLoaded = true;
        } else {
          this.onHandleCloseModal("safetyPopupModal");
        }
      } catch (error) {
        console.log("Error in getting terms and Conditions ", error);
      }
    },

        // <----Back button close modal---->
    handleBackbutton() {
      if (this.onChangeSafetyPopupModal) {
        this.onHandleCloseModal("safetyPopupModal"); 
      }
    },
  },
   
  //  beforeMount() {
  //   this.getTermsConditions();
  // window.addEventListener("popstate", this.handlePopstate);
  
  //  },
  async mounted() {
  await this.getTermsConditions();
  window.addEventListener("popstate", this.handleBackbutton);
},
 beforeDestroy() {
    window.removeEventListener("popstate", this.handleBackbutton);
  },
};
</script>
<style>
.tnc-popup-list li {
  line-height: 1.4;
  font-size: 12px;
  margin-bottom: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/modals/safetyPopup.vue